import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { IMessage, IUser } from 'src/model';

interface IWorkspaceMessageProps {
  message: IMessage;
  receiver: IUser;
  sender: IUser;
}

export const WorkspaceMessage: React.SFC<IWorkspaceMessageProps> = ({
  message,
  receiver,
  sender,
}) => {
  const receiverPictureUrl =
    receiver.profile.picture && receiver.profile.picture.pictureUrl;
  const senderPictureUrl =
    sender.profile.picture && sender.profile.picture.pictureUrl;

  return sender._id === message.sender ? (
    <Row className='w-100 mb-3'>
      <Col xs='2'>
        {senderPictureUrl ? (
          <img
            className='d-block rounded-circle'
            src={senderPictureUrl}
            style={{ height: '50px', width: '50px' }}
          />
        ) : (
          <div
            className='d-flex justify-content-around align-items-center rounded-circle font-weight-bold text-white bg-success mr-4'
            style={{ fontSize: '18px', height: '50px', width: '50px' }}
          >
            {`${sender.firstname[0]}${sender.lastname[0]}`}
          </div>
        )}
      </Col>
      <Col xs='10'>
        <span className='d-block rounded bg-white p-3'>{message.text}</span>
      </Col>
    </Row>
  ) : (
    <Row className='w-100 mb-3'>
      <Col xs='10'>
        <span className='d-block rounded bg-white p-3'>{message.text}</span>
      </Col>
      <Col xs='2'>
        {receiverPictureUrl ? (
          <img
            className='d-block rounded-circle'
            src={receiverPictureUrl}
            style={{ height: '50px', width: '50px' }}
          />
        ) : (
          <div
            className='d-flex justify-content-around align-items-center rounded-circle font-weight-bold text-white bg-success mr-4'
            style={{ fontSize: '18px', height: '50px', width: '50px' }}
          >
            {`${receiver.firstname[0]}${receiver.lastname[0]}`}
          </div>
        )}
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Project/ProjectWorkspace/WorkspaceMessageList/WorkspaceMessage.tsx